import { Injectable } from '@angular/core';

import { LoginRedirectService } from './login-redirect.service';
import { LoggedInService } from './logged-in.service';

@Injectable()
export class AuthGuardService {
  constructor(
    private loggedInService: LoggedInService,
    private loginRedirect: LoginRedirectService
  ) {}

  canActivate(): boolean {
    if (!this.loggedInService.isLoggedIn()) {
      this.loginRedirect.redirectWithState();
      return false;
    }
    return true;
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }
}
